<div *ngIf="study"
  class="container open-preview"
  cdkOverlayOrigin
  [id]="study.id"
  (click)="openPreview(study)"
  #previewButton>
  <div class="material-icons-outlined"> image_search </div>
  <div class="counter">{{ study.nbInstances }}</div>
</div>
